/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import gallery6 from "../../assets/gallery6.jpg";
import gallery7 from "../../assets/gallery7.jpg";
import gallery8 from "../../assets/gallery8.jpg";
import gallery9 from "../../assets/gallery9.jpg";
import gallery10 from "../../assets/gallery10.jpg";

function GalleryKindergarten() {
  return (
    <section className="pics-gallery-wrapper">
      <img src={gallery6} />
      <img src={gallery7} />
      <img src={gallery8} className="gallery-content1" />
      <img src={gallery9} />
      <img src={gallery10} />
    </section>
  );
}

export default GalleryKindergarten;
